const AdminActionTypes = {
    SET_ADMIN_ID: "SET_ADMIN_ID",
    SET_BREAKOUT_ROOM_NUMBER: "SET_BREAKOUT_ROOM_NUMBER",
    SET_DEBUG: "SET_DEBUG",
    SET_MODAL_MESSAGES: "SET_MODAL_MESSAGES",
    SET_SERVER_WAIT: "SET_SERVER_WAIT",
};

export default AdminActionTypes;